import { STAT_KEYS, STAT_MAX, STAT_MIN, STAT_TOTAL, type StatKey } from './constants/customize';
import type { LoadoutStats } from '../account/loadout-client';

export type PillState = 'settled' | 'pending-filled' | 'pending-emptied' | 'empty';

export function pillState(savedValue: number, pendingValue: number, index: number): PillState {
  const lo = Math.min(savedValue, pendingValue);
  const hi = Math.max(savedValue, pendingValue);
  if (index < lo) return 'settled';
  if (index < hi) return pendingValue > savedValue ? 'pending-filled' : 'pending-emptied';
  return 'empty';
}

export function pointsUsed(stats: LoadoutStats): number {
  return STAT_KEYS.reduce((sum, key) => sum + stats[key], 0);
}

export function remaining(stats: LoadoutStats): number {
  return STAT_TOTAL - pointsUsed(stats);
}

export function pointsMoved(saved: LoadoutStats, pending: LoadoutStats): number {
  return Math.floor(
    STAT_KEYS.reduce((sum, key) => sum + Math.abs(saved[key] - pending[key]), 0) / 2,
  );
}

export function costOf(
  saved: LoadoutStats,
  pending: LoadoutStats,
  creditsPerPoint: number,
): number {
  return pointsMoved(saved, pending) * creditsPerPoint;
}

export function canIncrease(stats: LoadoutStats, key: StatKey, loggedIn: boolean): boolean {
  return loggedIn && stats[key] < STAT_MAX && remaining(stats) > 0;
}

export function canDecrease(stats: LoadoutStats, key: StatKey, loggedIn: boolean): boolean {
  return loggedIn && stats[key] > STAT_MIN;
}

export function canConfirm(state: {
  loggedIn: boolean;
  stats: LoadoutStats;
  cost: number;
  credits: number;
  confirming: boolean;
  hasSaved: boolean;
}): boolean {
  return (
    state.loggedIn &&
    remaining(state.stats) === 0 &&
    state.cost <= state.credits &&
    !state.confirming &&
    state.hasSaved
  );
}
